import { Component } from '@theme/component';
import { DialogOpenEvent } from '@theme/dialog';
import { ThemeEvents } from '@theme/events';
import '@theme/na-cart-quantity';
import '@theme/na-cart-remove';
import '@theme/na-cart-addon';
import '@theme/na-cart-variant-swap';
import {
    closeFreeProductPopup,
    closeRecommendedProductPopup,
    maybeOpenFreeProductPopup,
    maybeOpenRecommendedProductPopup,
} from '@theme/na-cart-free-gifts';
import { updateFreeShippingBar } from '@theme/na-cart-free-shipping';

class CartItemEditorToggleComponent extends Component {
    /**
     * @param {Event} event
     */
    toggle(event) {
        event.preventDefault();
        const editor = this.querySelector('.cart-item-variant-editor');
        if (!editor) return;

        document.querySelectorAll('.cart-item-variant-editor.is-open').forEach((other) => {
            if (other !== editor) other.classList.remove('is-open');
        });
        editor.classList.toggle('is-open');
    }
}

class NaCartRuntimeComponent extends Component {
    closeFreeProductPopup() {
        closeFreeProductPopup();
    }

    closeRecommendedProductPopup() {
        closeRecommendedProductPopup();
    }
}

if (!customElements.get('cart-item-editor-toggle-component')) {
    customElements.define('cart-item-editor-toggle-component', CartItemEditorToggleComponent);
}

if (!customElements.get('na-cart-runtime-component')) {
    customElements.define('na-cart-runtime-component', NaCartRuntimeComponent);
}

function openDrawerFromSession() {
    if (sessionStorage.getItem('openCartDrawer') !== 'true') return;
    sessionStorage.removeItem('openCartDrawer');
    const drawer = document.querySelector('cart-drawer-component');
    if (drawer && typeof (/** @type {any} */ (drawer).open) === 'function') {
        /** @type {any} */ (drawer).open();
    }
}

function readMissingRecommendedCount() {
    const source = /** @type {HTMLElement | null} */ (
        document.querySelector('.recommended-products-source .recommended-item-card-main')
    );
    return parseInt(source?.dataset.missingCount ?? '0', 10) || 0;
}

customElements.whenDefined('cart-drawer-component').then(() => {
    openDrawerFromSession();
    updateFreeShippingBar();

    let missingRecommendedCount = readMissingRecommendedCount();
    const drawerEl = document.querySelector('cart-drawer-component');
    drawerEl?.addEventListener(DialogOpenEvent.eventName, () => {
        missingRecommendedCount = readMissingRecommendedCount();
        updateFreeShippingBar();
        maybeOpenFreeProductPopup();
        maybeOpenRecommendedProductPopup();
    });

    document.addEventListener(ThemeEvents.cartUpdate, () => {
        const previousCount = missingRecommendedCount;
        missingRecommendedCount = readMissingRecommendedCount();
        const drawerOpen = /** @type {HTMLDialogElement | null} */ (drawerEl?.querySelector('dialog'))?.open;
        if (drawerOpen && missingRecommendedCount > previousCount) maybeOpenRecommendedProductPopup();
    });
});
